<template>
  <div class="trace">
    <header>
      <!-- 模块名称 -->
      <div class="name">产品溯源</div>
      <div class="product-status" v-if="!loading">
        <img class="product-status-icon" src="../../assets/certification.png" />
        <div class="product-status-value">已认证</div>
        <!-- 农作物选择 -->
        <Dropdown class="list" @on-click="handleClick">
          <div class="dropdown-title">
            <span class="dropdown-name">{{ getProductName }}</span>
            <Icon class="dropdown-icon" type="md-arrow-dropdown" />
          </div>
          <DropdownMenu class="dropdown-list" slot="list">
            <DropdownItem v-for="(item, index) in getPlants" :key="index" :name="index">{{ item.key }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </header>
    <!-- 加载状态 -->
    <Spin class="loading" v-if="loading">
      <div class="loading-container">
        <Icon class="demo-spin-icon-load" type="ios-loading" size="18" />
        <div class="loading-text">加载中</div>
      </div>
    </Spin>
    <!-- 数据为空的状态 -->
    <div class="empty" v-else-if="empty">请在PC端配置溯源信息</div>
    <!-- 具体内容 -->
    <div class="content" v-else>
      <div class="component-view">
        <component :is="nowSelectedTab" @check-more-pictures="checkMorePictures" />
      </div>
      <ul class="select-tab">
        <li
          class="select-tab-item"
          :class="nowSelectedTab === item.value ? 'tab-item-selected' : ''"
          v-for="item in tab"
          :key="item.value"
          @click="handleSwitchEvent(item.value)">
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import crop from "./module/crop";
import env from "./module/env";
import farm from "./module/farm";
import record from "./module/record";
import report from "./module/report";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "trace",
  data() {
    return {
      tab: [
        {
          label: "环境",
          value: "env"
        },
        {
          label: "农事",
          value: "record"
        },
        {
          label: "农场",
          value: "farm"
        },
        {
          label: "作物",
          value: "crop"
        },
        {
          label: "报告",
          value: "report"
        }
      ],
      loading: true,
      empty: false,
      nowSelectedTab: "farm",
      plant: 0
    };
	},
	async mounted() {
    await this.traceMessage({
      index: 0
    })
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
        this.empty = true;
      });
	},
	computed: {
		...mapGetters("trace", ["getProductName", "getPlants"])
	},
  methods: {
    ...mapActions("trace", ["traceMessage"]),
    ...mapMutations("trace", ["setTraceId"]),
    handleSwitchEvent(tabValue) {
      this.nowSelectedTab = tabValue;
    },
    handleClick(e) {
      // console.log(e);
      this.setTraceId({
        index: e
      });
      this.traceMessage({
        index: e
      })
        .then(() => {
          this.loading = false;
        });
    },
    // 向view/bigData.vue父组件传递打开图片预览弹窗
    checkMorePictures(status) {
      this.$emit("check-more-pictures", status);
    }
  },
  components: {
    crop,
    env,
    farm,
    record,
    report
  }
};
</script>

<style scoped>
.trace {
  position: absolute;
  top: calc((100% - 80px) / 3 * 2 + 60px);
  right: 20px;
  width: 26.615vw;
  height: calc((100% - 80px) / 3);
  background-color: rgba(0, 40, 69, 0.8);
  border-radius: 0.5vw;
}

header {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.name {
  font-size: 1.172vw;
  padding-left: 1vw;
}

.product-status {
  display: flex;
  align-items: center;
  padding-right: 1vw;
}

.product-status-icon {
  width: 1vw;
  height: 1vw;
  margin-right: 0.3vw;
}

.product-status-value {
  color: #02bae1;
  font-size: 0.8vw;
  margin-right: 0.3vw;
}

.loading {
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-container {
  display: flex;
  align-items: center;
}

.loading-text {
  font-size: 0.6vw;
  padding-left: 0.2vw;
}

.empty {
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6vw;
  color: #808695;
}

.list {
  margin-left: 0.5vw;
  width: 4.6vw;
  background-color: #000c15;
  padding: 0.1vw 0.3vw;
}

.list >>> .ivu-select-dropdown {
  background-color: #000c15;
  margin: 8px 0px;
  padding: 0px;
}

.ivu-dropdown-item {
  color: #ffffff;
  padding: 0.1vw 0.3vw;
  width: 4.6vw;
  font-size: 0.6vw !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ivu-dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.dropdown-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropdown-name {
  max-width: 6vw;
  font-size: 0.6vw;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.dropdown-icon {
  font-size: 1vw;
  color: #00cdff;
}

.dropdown-list {
  max-height: 4vw;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #000c15;
}

.content {
  position: relative;
  width: 100%;
  height: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1vw;
}

.component-view {
  position: relative;
  width: 100%;
  height: 86%;
}

.select-tab {
  position: relative;
  width: 100%;
  height: 14%;
  list-style: none;
  padding: 0.1vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.select-tab-item {
  color: #00589e;
  padding: 0.1vw 1vw;
  font-size: 0.6vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select-tab-item:hover {
  cursor: pointer;
}

.tab-item-selected {
  border-radius: 0.1vw;
  border: solid 0.0125rem rgba(0, 189, 237, 1);
  color: #ffffff;
}
</style>
